export default "__VITE_ASSET__Pi9B3cUB__"